
import React, {useRef, useState} from 'react';
import Button from '../Button';
import {useIsMobile} from "../../../../hooks/useIsMobile";
import {css} from "@emotion/react";
import { motion, useInView } from "framer-motion";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import LoginModal from "../../../../common/layouts/modal/LoginModal";
import Alert from "../../../../common/layouts/modal/Alert";
import { trackEvent } from '../../../../lib/analytics';


export const animCss = css`
    
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .fade-in-delayed {
        animation: fadeIn 0.6s ease forwards;
        opacity: 0;
    }
    .fade-in-delay-1 {
        animation-delay: 0.2s;
    }
    .fade-in-delay-2 {
        animation-delay: 0.3s;
    }


    .btn-interactive {
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .btn-interactive:hover {
        transform: scale(1.05);
    }
    .btn-interactive:active {
        transform: scale(0.97);
    }


`;



const HeroSection: React.FC = () => {

    const navigate = useNavigate();

    const [showAlert, setShowAlert] = useState<false | "already" | "waiting" | "deactivated">(false);

    const [authorStatus, setAuthorStatus] = useState<string | null>(null);



    const [nickName, setNickName] = useState(() => localStorage.getItem('nickName') || '로그인');

    const [token, setToken] = useState('');

    const handleClick = () => {
        trackEvent('click_landing_cta', {
            cta_name: 'author_register',
            page_path: window.location.pathname,
        });

        const currentStatus = localStorage.getItem("authorStatus");

        if (!currentStatus || currentStatus === "null" || currentStatus === "undefined") {
            setShowSignup(true);

        } else {
            const status = currentStatus.toLowerCase();
            if (status === "author" || status === "active") { // 이미 로그인한 상태 & 작가면
                setShowAlert("already");
            } else if (status === "hold") {
                setShowAlert("deactivated");
            } else if (status === "pending" || status === "w") {
                setShowAlert("waiting");
            } else {
                navigate("/addAuthor"); //이미 로그인한 유저면 작가 등록 페이지
            }
        }
    };


    const [showSignup, setShowSignup] = useState(false);


    const closeModal = () => {
        setShowSignup(false);
    };



    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-100px" }); // -100px은 약간 일찍 시작


    const isMobile = useIsMobile();

    return (
        <section css={animCss}
            className="p-[70px] md:py-[48px] md:px-[43px]  text-center"
            style={{ background: 'linear-gradient(90deg, #FEFFFE 0%, #E1F9EE 100%)' }}
        >
            <div className="gap-[42px] md:gap-8 flex flex-col">
                  <span className="text-[48px] font-semibold text-[#111827] tracking-[0.96px] leading-[64px] md:leading-[40px] md:text-[30px] animate-fadeUp"
                  >
                    책에 담지 못한 <br />
                    <span className="text-main text-[50px] md:text-[32px] font-extrabold tracking-[1px] whitespace-nowrap">당신의 이야기</span>를 <br/>
                    들려주세요.
                  </span>


            <span className="text-[#6C7B7F] block  font-medium md:font-medium  leading-[39px] md:leading-[24px] text-2xl md:text-sm fade-in-delayed fade-in-delay-1">
                    작가와 독자가 글로 만나는 공간, 북밋.<br />
                    지금 바로 여러분의 이야기를 독자에게 전해보세요!
                </span>

                <div className="flex justify-center items-center  md:flex-col gap-6 md:gap-3 fade-in-delayed fade-in-delay-2">
                    <Button className="bg-main   rounded-full md:rounded-[30px] text-white font-bold flex justify-center items-center
                          h-[68px] md:h-[38px]
                          text-[22px] md:text-sm
                          px-[36.344px] md:px-4
                          py-[23px] md:w-[130px] [box-shadow:0_4px_8px_0_rgba(0,128,96,0.20)]"
                            onClick={handleClick}
                    >
                        작가로 시작하기
                    </Button>

                   {/* <Button className="border-[2px] md:border-[1px] border-main  rounded-full text-main font-bold flex justify-center items-center
                          h-[68px] md:h-[36px]
                          text-[20px] md:text-xs
                          px-[36.344px] md:px-4
                          py-[23px] md:py-[10px]"
                    >
                        독자로 둘러보기
                    </Button>*/}
                </div>


            </div>

            {showSignup && (
                <LoginModal
                    setNickName={setNickName}
                    token={token}
                    setToken={setToken}
                    onClose={() => {
                        setShowSignup(false);
                        const authorStatus: string | null = localStorage.getItem("authorStatus");
                        //console.log("홈탭 로그인:::", authorStatus);

                        if (authorStatus === "author") { //작가면 마이페이지
                            localStorage.setItem("redirectAfterReload", "/mypage");
                        } else {
                            localStorage.setItem("redirectAfterReload", "/addAuthor"); //user면 작가 등록 페이지
                        }

                        window.location.reload();
                    }}
                    closeModal={closeModal}
                />
            )}

            {showAlert && (
                <Alert
                    title="알림"
                    message={
                        showAlert === "already"
                            ? "이미 작가로 등록되어있어요!\n작가님의 다양한 작품 활동 소식을 많이 알려주세요 :)"
                            : showAlert === "deactivated"
                            ? "이미 작가로 등록되어있습니다."
                            : "이미 작가 등록 신청을 해주셨어요!\n운영진이 꼼꼼하게 검토하고 빠르게 안내해 드릴게요."
                    }
                    onClose={() => {
                        setShowAlert(false);
                    }}
                />
            )}

        </section>
    );
};

export default HeroSection;
